import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import './ShowHint.css';

interface ShowHintProps {
  visible: boolean;
  message: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
  onClose?: () => void;
}

const ShowHint: React.FC<ShowHintProps> = ({ 
  visible, 
  message: hintMessage, 
  type = 'info', 
  duration = 3000,
  onClose 
}) => {
  const [isVisible, setIsVisible] = useState(visible);

  useEffect(() => {
    if (visible) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        onClose?.();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [visible, duration, onClose]);

  if (!isVisible) return null;

  return (
    <div className={`show-hint show-hint-${type}`}>
      <div className="hint-content">
        <span className="hint-icon">
          {type === 'success' && <CheckCircleOutlined />}
          {type === 'error' && <CloseCircleOutlined />}
          {type === 'warning' && <ExclamationCircleOutlined />}
          {type === 'info' && <InfoCircleOutlined />}
        </span>
        <span className="hint-text">{hintMessage}</span>
      </div>
    </div>
  );
};

export default ShowHint; 